import {
  blocksOptionsConfig,
  newCollectionTemplate,
} from "@components/cmsBlocks/configs";
export const typeSlider = blocksOptionsConfig.collectionTypes.sliderV6.value;

export const sliderConfig = newCollectionTemplate({
  typeFields: {
    date: "date",
    title: "text",
    description: "textarea",
    image: "image",
    alt: "text",
    link: "text",
    isShow: "boolean",
  },
  itemTemplate: {
    date: new Date(),
    title: "title",
    description: "description",
    image: "",
    alt: "",
    link: "",
    isShow: true,
  },
  type: typeSlider,
  allowUseSet: false,
  showAsTitle: "title", // only texts fields
});

// export const sliderConfig1 = {
//   typeFields: {
//     date: "date",
//     title: "text",
//     description: "textarea",
//     image: "image",
//     alt: "text",
//     link: "text",
//   },
//   itemTemplate: {
//     date: new Date(),
//     title: "title",
//     description: "description",
//     image: "",
//     alt: "",
//     link: "",
//   },
//   type: typeSlider,
//   allowUseSet: false,
//   showAsTitle: "title", // only texts fields
// };

export const initBlockData = {
  title: "Our favorite events in Riga",
  collections: {
    [typeSlider]: {
      ...sliderConfig,
      items: [
        // {
        //   ...slider.slideTemplate,
        //   date: new Date(2023, 7, 26),
        //   title: 'Bryan Adams exhibition "Exposed" in Fotografiska 2',
        //   description:
        //     '"Exposed" is a retrospective of Adams’ friends and colleagues in the entertainment, fashion and art industries, including Morrissey, Ben Kingsley, Amy Winehouse, Michael Jackson. The exhibition also showcases his series "Wounded: The Legacy of War" where Adams presents portraits of young British soldiers. The exhibition is opened from March 6th till June 14th.',
        //   alt: "luxexpress bus",
        //   link: "/en/links",
        //   image:
        //     "https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/lux-express-kohtla-ja%CC%88rve-liinimuudatus_AyW6TKODs7.jpg",
        // },
        // {
        //   ...slider.slideTemplate,
        //   date: new Date(),
        //   title: 'Bryan Adams exhibition "Exposed" in Fotografiska 1',
        //   description:
        //     '"Exposed" is a retrospective of Adams’ friends and colleagues in the entertainment, fashion and art industries, including Morrissey, Ben Kingsley, Amy Winehouse, Michael Jackson. The exhibition also showcases his series "Wounded: The Legacy of War" where Adams presents portraits of young British soldiers. The exhibition is opened from March 6th till June 14th.',
        //   alt: "luxexpress bus",
        //   link: "/en/links",
        //   image:
        //     "https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/lux-express-kohtla-ja%CC%88rve-liinimuudatus_AyW6TKODs7.jpg",
        // },
        // {
        //   ...slider.slideTemplate,
        //   date: new Date(2023, 7, 24),
        //   title: 'Bryan Adams exhibition "Exposed" in Fotografiska 2',
        //   description:
        //     '"Exposed" is a retrospective of Adams’ friends and colleagues in the entertainment, fashion and art industries, including Morrissey, Ben Kingsley, Amy Winehouse, Michael Jackson. The exhibition also showcases his series "Wounded: The Legacy of War" where Adams presents portraits of young British soldiers. The exhibition is opened from March 6th till June 14th.',
        //   alt: "luxexpress bus",
        //   link: "/en/links",
        //   image:
        //     "https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/lux-express-kohtla-ja%CC%88rve-liinimuudatus_AyW6TKODs7.jpg",
        // },
        // {
        //   ...slider.slideTemplate,
        //   date: new Date(2022, 7, 23),
        //   title: 'Bryan Adams exhibition "Exposed" in Fotografiska 3',
        //   description:
        //     '"Exposed" is a retrospective of Adams’ friends and colleagues in the entertainment, fashion and art industries, including Morrissey, Ben Kingsley, Amy Winehouse, Michael Jackson. The exhibition also showcases his series "Wounded: The Legacy of War" where Adams presents portraits of young British soldiers. The exhibition is opened from March 6th till June 14th.',
        //   alt: "luxexpress bus",
        //   link: "/en/links",
        //   image:
        //     "https://luxexpress.fra1.cdn.digitaloceanspaces.com/media/lux-express-kohtla-ja%CC%88rve-liinimuudatus_AyW6TKODs7.jpg",
        // },
      ],
    },
  },
};
export const initEmptyBlockData = {
  title: "",
  collections: {
    [typeSlider]: {
      ...sliderConfig,
      items: [],
    },
  },
};
